export const MAX_LENGTH_SMS = 160;
export const URL_REGEX = /https?:\/\/\S+/g;
export const URL_TO_REPLACE = 'https://w.eulb.me/xxxxxxxx';
